import { makeVar } from '@apollo/client';

export const isInvoicesFirstLoadVar = makeVar(false);

export const offerDateToPaySelected = makeVar({});

export const preofferSelected = makeVar([]);

export const offerSelected = makeVar([]);
